import { render } from "./PauseClaimModal.vue?vue&type=template&id=437b9e41"
import script from "./PauseClaimModal.vue?vue&type=script&lang=js"
export * from "./PauseClaimModal.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./PauseClaimModal.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_828d00b8%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fclaim%2FPauseClaimModal.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__